import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MmButtonModule, MmFlexLayoutModule, MmIconModule } from '@metromarkets/components';
import { TranslateModule } from '@ngx-translate/core';
import { SubsidiaryAlertComponent } from '~shared/components/subsidiary-alert/subsidiary-alert.component';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [
    SubsidiaryAlertComponent
  ],
  exports: [
    SubsidiaryAlertComponent
  ],
  imports: [
    CommonModule,
    MmIconModule,
    TranslateModule,
    MmButtonModule,
    MmFlexLayoutModule,
    RouterModule
  ]
})
export class SubsidiaryAlertModule {
}
